export default {
  methods: {
    Download: function (file, isEncrypt, hashed) {
      console.log(
        `[download.js] Download function called for: ${file.original_file_name}`,
      );
      return new Promise((resolve, reject) => {
        let url;

        if (isEncrypt) {
          url = `${import.meta.env.VITE_API_URL}/file/get?external_id=${encodeURIComponent(file.external_id)}&hashed=${encodeURIComponent(hashed)}&download=true`;
        } else {
          url = file["download_url"];
        }
        console.log(`[download.js] Download URL: ${url}`);

        const notifyDownload = () => {
          if (file.user_id !== this.$store.state.user.sub) {
            return this.$axios.get(
              `/file/download-notification?external_id=${encodeURIComponent(file.external_id)}`,
            ).catch((err) => {
              // 通知APIがエラーになってもダウンロードを続行するため、ログ出力のみ行う
              console.warn("[download.js] Download notification failed, but continuing with download:", err);
              return Promise.resolve(); // エラーが発生してもダウンロードを続行
            });
          }
          return Promise.resolve();
        };

        notifyDownload()
          .then(() => {
            if (window.flutterSendMessage) {
              window.flutterSendMessage.postMessage(
                JSON.stringify({
                  type: "download",
                  message: { fileName: file.file_name, url: url },
                }),
              );
              resolve();
            } else {
              const newWindow = window.open(url, "_blank");
              if (newWindow) {
                newWindow.focus();
                resolve();
              } else {
                // window.open が null を返した場合 (ポップアップブロックなど)
                console.error(
                  "[download.js] window.open failed. It returned null. Pop-up likely blocked.",
                );
                reject(
                  new Error(
                    "Failed to open new window. Pop-up may be blocked by the browser.",
                  ),
                );
              }
            }
          })
          .catch((err) => {
            console.error("[download.js] Error during download process:", err);
            reject(err);
          });
      });
    },
    /**
     * 文字列をダウンロード可能なファイルとしてユーザーに提供する関数
     * @param {string} content - ダウンロードする内容となる文字列
     * @param {string} fileName - ダウンロードするファイルの名前
     * @param {string} contentType - ファイルのコンテンツタイプ（例: 'text/plain'）
     */
    DownloadStringAsFile: function (content, fileName, contentType) {
      const blob = new Blob([content], { type: contentType });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    /**
     * Blob オブジェクトをダウンロード可能なファイルとしてユーザーに提供する関数
     * @param {Blob} blob - ダウンロードする Blob オブジェクト
     * @param {string} fileName - ダウンロードするファイルの名前
     */
    DownloadBlob: function (blob, fileName) {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href); // メモリリークを防ぐために Object URL を解放
    },
  },
};
